import * as EventType from '../types/events.types'
import {startOfDay} from 'date-fns'

const fb = require('../../config/firebase.js');

const eventHandler = function (event, id) {
  if (event.startDate)
    event.startDate = event.startDate.toDate();
  if (event.endDate)
    event.endDate = event.endDate.toDate();
  if (event.eventCreated)
    event.eventCreated = event.eventCreated.toDate();
  if (event.lastUpdated)
    event.lastUpdated = event.lastUpdated.toDate();

  event.id = id;

  return event;
}

const module = {
  namespaced: true,
  state: {
    events: {},
    changeCount: 0,
    pulledNextEvent: undefined,
    hiddenEventsPulled: false,
  },
  getters: {
    getEventChangeCount(state) {
      return state.changeCount;
    },
    getNextEvents (state) {
      return state.pulledNextEvent;
    },
    isHiddenEventsPulled(state) {
      return state.hiddenEventsPulled;
    }
  },
  mutations: {
    [EventType.ADD_EVENT](state, payload) {
      const formattedEvent = eventHandler(payload.data(), payload.id);
      state.events[payload.id] = formattedEvent;

      if (state.pulledNextEvent &&
          state.pulledNextEvent[payload.id] &&
          !formattedEvent.hidden){
        state.pulledNextEvent[payload.id] = formattedEvent;
      }


      state.changeCount += 1;
    },
    [EventType.CLEAR_EVENTS](state) {
      state.events = {};
      state.changeCount = 0;
      state.pulledNextEvent = undefined;
      state.hiddenEventsPulled = false;
    },
    [EventType.ADD_PUBLIC_EVENTS](state, payload) {
      const events = {};
      payload.docs.forEach((res) => {
        if (res.exists) {
          const event = eventHandler(res.data(), res.id);
          state.events[res.id] = event;
          events[res.id] = event;
        }
      });

      state.pulledNextEvent = events;
      state.changeCount += 1;
    },
    [EventType.ADD_ALL_EVENTS](state, payload) {
      const events = {};
      payload.docs.forEach((res) => {
        if (res.exists) {
          const event = eventHandler(res.data(), res.id);
          state.events[res.id] = event;
          events[res.id] = event;
        }
      });

      if(!state.pulledNextEvent)
        state.pulledNextEvent = events;
      else {
        const keys = Object.keys(events);
        keys.forEach( (key) => {
          state.pulledNextEvent[key] = events[key];
        })
      }

      state.hiddenEventsPulled = true;
    }
  },
  actions: {
    async pullEvent ({ commit, state }, id) {
      const res = await fb.eventsCollection.doc(id).get();

      if(!res.exists)
        return undefined;

      commit(EventType.ADD_EVENT, res);
      return state.events[id]
    },
    async getEvent ({ state }, id) {
      return state.events[id];
    },
    async pullNextEvents ({ commit, state }, all) {
      let today = startOfDay(new Date())

      if (all) {
        const querySnapshot = await fb.eventsCollection
          .orderBy("startDate")
          .where("published", "==", true)
          .where('startDate', '>=', today)
          .limit(18).get();

        await commit(EventType.ADD_ALL_EVENTS, querySnapshot);
      }  else {
        const querySnapshot = await fb.eventsCollection
          .orderBy("startDate")
          .where("published", "==", true)
          .where("hidden", "==", false)
          .where('startDate', '>=', today)
          .limit(18).get();

        await commit(EventType.ADD_PUBLIC_EVENTS, querySnapshot);
      }

      return state.pulledNextEvent;
    },
  },
};
export default module;
